<template>
  <form class="my-3">

    <b-list-group class="text-capitalize mb-4">
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.vendor.timesheet)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.timesheets"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="timesheet_id" :label="$t($getConst.pages.vendor.timesheet_id)" label-for="timesheet_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="timesheet_id-input"
                            v-model.trim="$v.timesheet.timesheet_id.$model"
                            :class="{ 'is-invalid': $v.timesheet.timesheet_id.$error || timesheetExist }"
                            :placeholder="$t($getConst.pages.vendor.enter_timesheet_id)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.timesheet_id"/>
              <b-form-invalid-feedback v-if="timesheetExist">
                {{$t($getConst.pages.form.combination_exist_field_error)}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="timesheet_week_end_date" :label="$t($getConst.pages.vendor.timesheet_week_end_date)"
                          label-for="timesheet_week_end_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="timesheet_week_end_date-input"
                                 v-model.trim="$v.timesheet.timesheet_week_end_date.$model"
                                 :placeholder="$t(this.$getConst.pages.vendor.enter_timesheet_week_end_date)"
                                 :class="{ 'is-invalid': $v.timesheet.timesheet_week_end_date.$error }"
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 size="lg"
                                 required
                                 :locale="this.$store.getters['auth/scopeDefault'].format_date === 'DD/MM/YYYY'?'fr':'en'"
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.timesheet.timesheet_week_end_date"/>
            </b-form-group>
          </b-col>
        </b-row>

      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="contractor_name" :label="$t($getConst.pages.vendor.contractor_name)"
                          label-for="contractor_name-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="contractor_name-input"
                            v-model.trim="$v.timesheet.contractor_name.$model"
                            :class="{ 'is-invalid': $v.timesheet.contractor_name.$error }"
                            :placeholder="$t($getConst.pages.vendor.enter_contractor_name)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.contractor_name"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="sub_contractor_name" :label="$t($getConst.pages.vendor.sub_contractor_name)"
                          label-for="sub_contractor_name-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="sub_contractor_name-input"
                            v-model.trim="$v.timesheet.sub_contractor_name.$model"
                            :class="{ 'is-invalid': $v.timesheet.sub_contractor_name.$error }"
                            :placeholder="$t($getConst.pages.vendor.enter_sub_contractor_name)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.sub_contractor_name"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="assignment_id" :label="$t($getConst.pages.vendor.assignment_id)"
                          label-for="assignment_id-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="assignment_id-input"
                            v-model.trim="$v.timesheet.assignment_id.$model"
                            :class="{ 'is-invalid': $v.timesheet.assignment_id.$error }"
                            :placeholder="$t($getConst.pages.vendor.enter_assignment_id)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.assignment_id"/>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group id="timesheet_status" :label="$t($getConst.pages.vendor.timesheet_status)"
                          label-for="timesheet_status-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input v-else
                            id="timesheet_status-input"
                            v-model.trim="$v.timesheet.timesheet_status.$model"
                            :class="{ 'is-invalid': $v.timesheet.timesheet_status.$error }"
                            :placeholder="$t($getConst.pages.vendor.enter_timesheet_status)"
                            size="lg"
                            required
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.timesheet_status"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row>
          <b-col cols="6">
            <b-form-group id="timesheet_submitted_date" :label="$t($getConst.pages.vendor.timesheet_submitted_date)"
                          label-for="timesheet_submitted_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="timesheet_submitted_date-input"
                                 v-model.trim="$v.timesheet.timesheet_submitted_date.$model"
                                 :class="{ 'is-invalid': $v.timesheet.timesheet_submitted_date.$error }"
                                 :placeholder="$t(this.$getConst.pages.vendor.enter_timesheet_submitted_date)"
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 size="lg"
                                 required
                                 :locale="this.$store.getters['auth/scopeDefault'].format_date === 'DD/MM/YYYY'?'fr':'en'"
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.timesheet.timesheet_submitted_date"/>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group id="timesheet_approved_date" :label="$t($getConst.pages.vendor.timesheet_approved_date)"
                          label-for="timesheet_approved_date-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-datepicker v-else
                                 id="timesheet_approved_date-input"
                                 v-model.trim="$v.timesheet.timesheet_approved_date.$model"
                                 :class="{ 'is-invalid': $v.timesheet.timesheet_approved_date.$error }"
                                 :placeholder="$t(this.$getConst.pages.vendor.enter_timesheet_approved_date)"
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                 size="lg"
                                 required
                                 :locale="this.$store.getters['auth/scopeDefault'].format_date === 'DD/MM/YYYY'?'fr':'en'"
              ></b-form-datepicker>
              <AppFormFeedback :errors="$v.timesheet.timesheet_approved_date"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <!--   Vendor inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.vendor.timesheet_vendor_section_title)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="this.$getConst.svgIcons.vendor"/>
      </b-list-group-item>

      <b-list-group-item
        class="d-inline justify-content-between align-items-center font-size-lg pt-3 pb-0 bg-transparent">
        <b-row class="pb-2">
          <b-col cols="6">
            <b-form-group id="vendor_gp_id" :label="$t($getConst.pages.vendor.vendor_gp_id)"
                          label-for="vendor_gp_id-input">
              <multiselect v-model.trim="timesheet.vendor_gp_id"
                           :class="{ 'is-invalid': $v.timesheet.vendor_gp_id.$error }"
                           :placeholder="$t($getConst.pages.form.select_option)" :options="vendorIds"
                           :multiple="false" openDirection="bottom"
                           :searchable="true" :close-on-select="true"
                           :options-limit="300" :limit="3"
                           :max-height="600" :show-no-results="false"
                           @search-change="debounceVendors"
                           @input="changeVendorName"
                           :tag-placeholder="$t($getConst.pages.vendor.add_new_vendor)"
                           :taggable="true"
                           @tag="addNewVendor"

              >
                <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
              </multiselect>
              <AppFormFeedback :errors="$v.timesheet.vendor_gp_id"/>
              <b-form-invalid-feedback v-if="timesheetExist">
                {{$t($getConst.pages.form.combination_exist_field_error)}}.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group v-if="timesheet.vendor_gp_id && selectedVendorName"
                          :label="$t($getConst.pages.vendor.vendor_name)">
              {{ timesheet.vendor_name }}
            </b-form-group>
            <b-form-group v-else id="vendor_name" :label="$t($getConst.pages.vendor.vendor_name)"
                          label-for="vendor_name-input">
              <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
              <b-form-input id="vendor_name-input"
                            v-model.trim="$v.timesheet.vendor_name.$model"
                            :placeholder="$t(this.$getConst.pages.vendor.enter_vendor_name)"
                            size="lg"
                            required
                            autocomplete="off"
              ></b-form-input>
              <AppFormFeedback :errors="$v.timesheet.vendor_name"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-list-group-item>

      <!--   Work days inputs   -->
      <b-list-group-item
        class="list-group-section-title d-flex justify-content-between bg-light align-items-center bg-transparent">
        <div class="flex-grow-1">
          <h5 class="my-0 text-uppercase text-secondary font-weight-bold">
            {{$t($getConst.pages.vendor.work_days)}}</h5>
        </div>
        <AppSvgIcon height="2rem" :icon="$getConst.svgIcons.timesheets"/>
      </b-list-group-item>
      <div v-if="timesheet.work_days.length===0" class="text-center mb-2 mt-2">
        <b-button  variant="outline" size="lg" class="mr-1"
                  @click="addTimesheetWorkDays">
          {{$getConst.pages.button.add | capitalize}} <i :class="$getConst.icons.add" class="fs-20"></i>
        </b-button>

      </div>
      <template v-for="(work_days, index) in $v.timesheet.work_days.$each.$iter">
        <AppSection :id="'timesheet-work-days-'+index"
                    :title="'timesheet-work-days-'+increment(index)"
                    type="sub-section-2"
                    class="pl-4 pr-4 mt-4"
                    :button="timesheet.work_days.length > 1"
                    :button-icon="$getConst.icons.delete"
                    button-variant="outline-danger"
                    button-size="sm"
                    @onClick="confirmRemoveTimesheetWorkDays(index)"
        >
          <b-row>
            <b-col cols="6">
              <b-form-group id="timesheet_work_date" :label="$t($getConst.pages.vendor.timesheet_work_date)"
                            :label-for="'timesheet_work_date-input'+index">
                <date-picker :id="'date-picker'+index"  mode='range' v-model='work_days.timesheet_work_date.$model' is-range
                             :model-config="modelConfig" :locale="$store.getters['auth/scopeDefault'].format_date === 'DD/MM/YYYY'?'fr':'en'"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                      <b-form-input
                        v-if="inputValue.start == inputValue.end"
                        :id="'date'+index"
                        readonly="readonly"
                        :value="inputValue.start"
                        v-on="inputEvents.start"
                        :class="{ 'is-invalid': work_days.timesheet_work_date.$error }"
                        :placeholder="$t($getConst.pages.vendor.enter_timesheet_work_date)"
                        required
                      />
                      <b-form-input v-else
                                    :id="'date'+index"
                                    readonly="readonly"
                                    :value="inputValue.start +' - ' + inputValue.end"
                                    v-on="inputEvents.start"
                                    :class="{ 'is-invalid': work_days.timesheet_work_date.$error }"
                                    :placeholder="$t($getConst.pages.vendor.enter_timesheet_work_date)"
                                    required
                      />
                    <AppFormFeedback :errors="work_days.timesheet_work_date"/>
                  </template>
                </date-picker>
              </b-form-group>

            </b-col>
            <b-col cols="6">
              <b-form-group id="project_id"
                            :label="$t($getConst.pages.vendor.project_id)"
                            :label-for="'project_id-input'+index">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else
                              :id="'project_id-input'+index"
                              v-model.trim="work_days.project_id.$model"
                              :class="{ 'is-invalid': work_days.project_id.$error }"
                              :placeholder="$t($getConst.pages.vendor.enter_project_id)"
                              size="lg"
                              required
                ></b-form-input>
                <AppFormFeedback :errors="work_days.project_id"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group id="timesheet_earning_code"
                            :label="$t($getConst.pages.vendor.timesheet_earning_code)"
                            :label-for="'timesheet_earning_code-input'+index">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else
                              :id="'timesheet_earning_code-input'+index"
                              v-model.trim="work_days.timesheet_earning_code.$model"
                              :class="{ 'is-invalid': work_days.timesheet_earning_code.$error }"
                              :placeholder="$t($getConst.pages.vendor.enter_timesheet_earning_code)"
                              size="lg"
                              required
                ></b-form-input>
                <AppFormFeedback :errors="work_days.timesheet_earning_code"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group id="timesheet_day_quantity" :label="$t($getConst.pages.vendor.timesheet_day_quantity)"
                            :label-for="'timesheet_day_quantity-input'+index">
                <b-skeleton type="input" class="mt-0 mb-3 h-75" v-if="is_loading"></b-skeleton>
                <b-form-input v-else
                              :id="'timesheet_day_quantity-input'+index"
                              v-model.trim="work_days.timesheet_day_quantity.$model"
                              :class="{ 'is-invalid': work_days.timesheet_day_quantity.$error }"
                              :placeholder="$t($getConst.pages.vendor.enter_timesheet_day_quantity)"
                              size="lg"
                              required
                ></b-form-input>
                <AppFormFeedback :errors="work_days.timesheet_day_quantity"/>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="text-center mb-2 mt-2">
            <b-button v-if="index == timesheet.work_days.length-1" variant="outline" size="lg" class="mr-1"
                      @click="addTimesheetWorkDays">
              {{$getConst.pages.button.add | capitalize}} <i :class="$getConst.icons.add" class="fs-20"></i>
            </b-button>

          </div>
        </AppSection>
      </template>

    </b-list-group>

    <AppConfirmButtons
      :submit-text="$getConst.pages.button.save"
      :cancel-text="$getConst.pages.button.cancel_changes"
      :isLoading="save_is_loading"
      @onSubmit="submit"
      @onCancel="resetData"
    />

    <AppConfirmationModal
      id="confirmation-modal"
      :title=$t($getConst.pages.profile.are_you_sure) | capitalize
      ref="confirmDelete"
      @onCancel="cancelRemoveTimesheetWorkDays"
      @onConfirm="removeTimesheetWorkDays"/>

  </form>

</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";
  import {addTimesheet, editTimesheet, deleteWorkDays, getTimesheet, getVendorsForConnectedScope} from "../../api/vendorTimesheets.api";
  import {debounce} from "lodash";
  import AppSection from "../../components/common/sections/AppSection";
  import AppConfirmationModal from "../../components/common/modals/AppConfirmationModal";
  const initTimesheet = () => {
    return {
      work_days: [
        {
          timesheet_earning_code: '',
          timesheet_day_quantity: '',
          timesheet_work_date: '',
          project_id:''
        }
      ],
      timesheet_id: '',
      timesheet_week_end_date: '',
      contractor_name: '',
      sub_contractor_name: '',
      assignment_id: '',
      timesheet_status: '',
      timesheet_submitted_date: '',
      timesheet_approved_date: '',
      vendor_gp_id: '',
      vendor_name: '',
    }
  };

  export default {
    name: "TimesheetForm",
    components: {AppSection, AppConfirmButtons, AppFormFeedback, AppConfirmationModal},
    props: {
      timesheetToEditId: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        timesheet: initTimesheet(),
        timesheetExist: false,
        is_loading: false,
        save_is_loading: false,
        timesheetIds: [],
        searchIsLoading: false,
        workDaysToDelete: null,
        workDaysIndexToDelete: '',
        modelConfig: {
          type: 'string',
          mask: 'MM/DD/YYYY',
        },
        vendors: [],
        vendorIds: [],
        getVendorsIsLoading: false,
        selectedVendorName: null
      }
    },

    validations: {
      timesheet: {
        work_days: {
          $each: {
            timesheet_earning_code: {required},
            timesheet_day_quantity: {required},
            timesheet_work_date: {required},
            project_id: {required},
          }
        },
        timesheet_id: {required},
        timesheet_week_end_date: {required},
        contractor_name: {required},
        sub_contractor_name: {required},
        assignment_id: {required},
        timesheet_status: {required},
        timesheet_submitted_date: {required},
        timesheet_approved_date: {required},
        vendor_gp_id: {required},
        vendor_name: {},
      }
    },

    methods: {
      isFormInvalid() {
        this.$v.$touch();
        return this.$v.$invalid;

      },
      errorFromServerTreatment(error) {
        if (error.response.data.code === 422) {
          this.timesheetExist = 'timesheet' in error.response.data.error;
        } else {
          this.handleApiError(error);
        }
      },
      async getVendorsForConnectedScope(query) {
        if (query.length > 0) {
          this.timesheet.vendor_name = '';
          this.getVendorsIsLoading = true;
          await getVendorsForConnectedScope({vendor_gp_id: query}).then(
            response => {
              this.vendorIds = response.data.vendorIds;
              this.vendors = response.data.vendors;
              this.getVendorsIsLoading = false;
            },
            error => {
              this.handleApiError(error);
              this.getVendorsIsLoading = false;
            }
          );
        }
      },
      submit() {
        if (this.isFormInvalid()) {
          return;
        }
        this.save_is_loading = true;
        if (this.timesheetToEditId.length === 0) {
          addTimesheet(this.timesheet).then(
            response => {
              this.$snotify.success(this.$t(this.$getConst.pages.vendor.timesheet_added));
              this.save_is_loading = false;
              this.$router.push({name: this.$getConst.routesNames.vendortimesheets});
            },
            error => {
              this.errorFromServerTreatment(error);
              this.save_is_loading = false;
            }
          );
        } else {
          editTimesheet(this.timesheetToEditId, this.timesheet).then(
            response => {
              this.$snotify.success(this.$t(this.$getConst.pages.vendor.timesheet_updated));
              this.save_is_loading = false;
              this.$router.push({name: this.$getConst.routesNames.vendortimesheets});
            },
            error => {
              this.errorFromServerTreatment(error);
              this.save_is_loading = false;
            }
          );
        }
      },
      resetData() {
        if (this.timesheetToEditId.length !== 0) {
          this.getTimesheet();
        } else {
          this.timesheet = initTimesheet();
          this.$v.$reset();
        }
      },
      getTimesheet() {
        this.is_loading = true;
        getTimesheet(this.timesheetToEditId).then(
          response => {
            this.timesheet = response.data;
            this.selectedVendorName = this.timesheet.vendor_name;
            this.timesheet.timesheet_week_end_date = this.convertDate(this.timesheet.timesheet_week_end_date);
            this.timesheet.timesheet_submitted_date = this.convertDate(this.timesheet.timesheet_submitted_date);
            this.timesheet.timesheet_approved_date = this.convertDate(this.timesheet.timesheet_approved_date);
            this.timesheet.work_days.forEach(workDay => {
                workDay.timesheet_work_date.start = this.convertDate(workDay.timesheet_work_date.start);
                workDay.timesheet_work_date.end = this.convertDate(workDay.timesheet_work_date.end);
            })
            this.is_loading = false;
          },
          error => {
            if (error.response.status === 404) {
              this.$snotify.error(this.$getConst.pages.vendor.redirect_to_timesheets_page, this.$t(this.$getConst.pages.alerts.url_not_found));
            } else {
              this.handleApiError(error);
            }

            setTimeout(() => {
              this.$router.push({name: this.$getConst.routesNames.vendortimesheets});
            }, 5000);

            this.is_loading = false;
          }
        );
      },
      convertDate(date) {
        return date.split('/').reverse().join('-');
      },

      addTimesheetWorkDays() {
        this.timesheet.work_days.push({
          timesheet_earning_code: '',
          timesheet_day_quantity: '',
          project_id: '',
          timesheet_work_date: ''
        });
      },
      confirmRemoveTimesheetWorkDays(index) {
        if (this.timesheet.work_days[index].id === undefined) {
          this.timesheet.work_days.splice(index, 1);
        } else {
          this.workDaysToDelete = this.timesheet.work_days[index];
          this.workDaysIndexToDelete = index;
          this.$bvModal.show('confirmation-modal');
        }
      },
      removeTimesheetWorkDays() {
        deleteWorkDays(this.timesheet.id,this.workDaysToDelete).then(
          () => {
            this.timesheet.work_days.splice(this.workDaysIndexToDelete, 1);
            this.$refs.confirmDelete.close();
            this.$snotify.success(this.$t(this.$getConst.pages.vendor.work_days_deleted));
          },
          error => {
            this.$refs.confirmDelete.close();
            this.handleApiError(error);
          }
        );
      },
      cancelRemoveTimesheetWorkDays() {
        this.workDaysToDelete = null;
        this.workDaysIndexToDelete = '';
      },
      increment(index) {
        return parseInt(index) + 1;
      },
      changeVendorName(value) {
        if (this.vendors.length > 0 && this.timesheet.vendor_gp_id) {
          let vendor_name = this.vendors.find(vendor => vendor.gp_id === value).name;
              this.selectedVendorName = vendor_name;
              this.timesheet.vendor_name = vendor_name;
            } else {
              this.selectedVendorName = null;
              this.timesheet.vendor_name = '';
            }
      },
      addNewVendor(newVendor) {
        this.selectedVendorName = null;
        this.vendorIds.push(newVendor);
        this.timesheet.vendor_gp_id = newVendor;
        this.timesheet.vendor_name = '';
      }
    },
    created() {
      if (this.timesheetToEditId.length !== 0) {
        this.getTimesheet();
      }
      this.debounceVendors = debounce((query) => this.getVendorsForConnectedScope(query), 1000);

    },
  }
</script>

<style scoped>
  .list-group {
    border-radius: 0 !important;
  }

  .list-group-item {
    border-right: none !important;
    border-left: none !important;
  }

  .list-group-section-title {
    border-top: none !important;
  }

  .b-skeleton {
    height: 45px !important;
  }
</style>
